import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends ApiService {

  public list(data: any) {
    return this.getReportQueryParams(CONSTANTS.API.REPORT.GET_REPORTS, data);
  }
  public add(data: any) {
    return this.postReport(CONSTANTS.API.REPORT.ADD_REPORT, data);
  }
  public update(data: any) {
    return this.putReport(CONSTANTS.API.REPORT.UPDATE_REPORT, data);
  }
  public deleteReport(data: any) {
    return this.deleteReportQueryParams(CONSTANTS.API.REPORT.DELETE_REPORT, data);
  }
  public update_status(data: any) {
    return this.putReport(CONSTANTS.API.REPORT.UPDATE_STATUS, data);
  }
  public get_report_data(data: any) {
    return this.getReportQueryParams(CONSTANTS.API.REPORT.GET_REPORT_DATA, data);
  }
  public update_report_data(data: any) {
    return this.putReport(CONSTANTS.API.REPORT.UPDATE_REPORT_DATA, data);
  }
  public generate_report(data: any) {
    return this.getReportQueryParams(CONSTANTS.API.REPORT.GENERATE_REPORT, data);
  }
  public download_report(data: any) {
    return this.downloadReport(CONSTANTS.API.REPORT.DOWNLOAD_REPORT, data);
  }
}
